const wizard = {
  state: {
    routesWizard: [
      {
        path: '',
        component: 'OrderType',
        permission: true,
        tabbar: []
      },
      {
        path: 'subscription',
        component: 'SubscriptionDetails',
        permission: false,
        tabbar: ['subscription']
      },
      {
        path: 'items',
        component: 'Items',
        icon: 'shopping-cart',
        permission: false,
        tabbar: ['items', 'typed-sale']
      },
      {
        path: 'payment-method',
        component: 'PaymentMethod',
        icon: 'file-invoice-dollar',
        permission: false,
        tabbar: ['items', 'typed-sale']
      },
      {
        path: 'customer',
        component: 'Customer',
        icon: 'user',
        permission: false,
        tabbar: ['items', 'subscription', 'typed-sale']
      },
      {
        path: 'payment',
        component: 'PaymentData',
        icon: 'credit-card',
        permission: false,
        tabbar: ['items', 'subscription', 'typed-sale']
      },
      {
        path: 'review',
        component: 'ReviewOrder',
        permission: false,
        icon: 'clipboard',
        tabbar: ['items', 'subscription', 'typed-sale']
      },
      {
        path: 'order-created',
        component: 'OrderCreated',
        permission: false,
        tabbar: []
      },
      {
        path: 'options',
        component: 'Options',
        permission: false,
        tabbar: []
      },
      {
        path: 'products-services',
        component: 'PaymentLink',
        permission: false,
        tabbar: []
      },
      {
        path: 'link-settings',
        component: 'Link',
        permission: false,
        tabbar: []
      },
      {
        path: 'payment-methods',
        component: 'PaymentMethods',
        permission: false,
        tabbar: []
      },
      {
        path: 'success',
        component: 'Success',
        permission: false,
        tabbar: []
      }
    ],
    showFeedbacks: {
      status: false,
      address: false,
      boleto: false,
      credit_card: false
    }
  },
  getters: {
    routesWizard (state) {
      return state.routesWizard
    },
    showFeedbacks (state) {
      return state.showFeedbacks
    }
  },
  mutations: {
    setRoutesWizard (state, routes) {
      state.routesWizard = routes
    },
    setItemPermission (state, { index, permission }) {
      state.routesWizard[index].permission = permission
    },
    'SET_PERMISSION' (state, obj) {
      const i = state.routesWizard.filter(el => el.tabbar.includes(obj.paymentType)).findIndex(el => el.component === obj.component)
      const item = obj.status
        ? state.routesWizard.filter(el => el.tabbar.includes(obj.paymentType)).find((el, index) => i < index)
        : state.routesWizard.find(el => el.tabbar.includes(obj.paymentType) && !el.permission)
      if (item) {
        state.routesWizard = state.routesWizard.map(el => {
          if (el.component === item.component) el.permission = !obj.status
          return el
        })
      }
    },
    'RESET_PERMISSION' (state, value) {
      state.routesWizard = state.routesWizard.map(item => {
        if (item.component !== value) item.permission = false
        return item
      })
    },
    'SHOW_FEEDBACK_STATUS' (state, value) {
      state.showFeedbacks.status = value
    }
  },
  actions: {
    'SET_ROUTES_WIZARD' ({ commit }, routes) {
      commit('setRoutesWizard', routes)
    },
    'SET_ITEM_PERMISSION' ({ commit }, { index, permission }) {
      commit('setItemPermission', { index, permission })
    },
    'SET_PERMISSION' (context, obj) {
      context.commit('SET_PERMISSION', obj)
    },
    'RESET_PERMISSION' (context, value) {
      context.commit('RESET_PERMISSION', value)
    },
    'SHOW_FEEDBACK_STATUS' (context, value) {
      context.commit('SHOW_FEEDBACK_STATUS', value)
    }
  }
}

export default wizard
